module.exports = __webpack_public_path__ + "assets/img/组 148@2x.a142086f.png";